export const upgradePlanLink =
  "https://calendly.com/mustard-influencers/upgrade-plan";

export const foodInfluencersCollabLink =
  "https://calendly.com/mustard-influencers/food-influencers-collab?embed_domain=www.mustard.love&embed_type=PopupText&hide_event_type_details=1&hide_gdpr_banner=1&primary_color=ff7a00";
